import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, dark = false }) {
  return (
    <Reveal className="mx-auto max-w-2xl text-center">
      {eyebrow && (
        <span className={`text-sm font-semibold tracking-wide ${dark ? "text-gold" : "text-gold-dark"}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`mt-2 font-head text-3xl font-extrabold leading-snug sm:text-4xl ${dark ? "text-cream" : "text-forest-950"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 leading-relaxed ${dark ? "text-cream/70" : "text-moss"}`}>{subtitle}</p>
      )}
    </Reveal>
  );
}
